import { render, staticRenderFns } from "./LinkFile.vue?vue&type=template&id=4fdc0c67&"
import script from "./LinkFile.vue?vue&type=script&lang=js&"
export * from "./LinkFile.vue?vue&type=script&lang=js&"
import style0 from "./LinkFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports